/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FinancialSupportDemoCompanyDto } from '../models/financial-support-demo-company-dto';
import { FinancialSupportDemoCompanySummaryDto } from '../models/financial-support-demo-company-summary-dto';
import { financialSupportDemoControllerFindAll } from '../fn/financial-support-demo/financial-support-demo-controller-find-all';
import { FinancialSupportDemoControllerFindAll$Params } from '../fn/financial-support-demo/financial-support-demo-controller-find-all';
import { financialSupportDemoControllerFindCredit } from '../fn/financial-support-demo/financial-support-demo-controller-find-credit';
import { FinancialSupportDemoControllerFindCredit$Params } from '../fn/financial-support-demo/financial-support-demo-controller-find-credit';
import { financialSupportDemoControllerFindGrantBenefits } from '../fn/financial-support-demo/financial-support-demo-controller-find-grant-benefits';
import { FinancialSupportDemoControllerFindGrantBenefits$Params } from '../fn/financial-support-demo/financial-support-demo-controller-find-grant-benefits';
import { financialSupportDemoControllerFindLoans } from '../fn/financial-support-demo/financial-support-demo-controller-find-loans';
import { FinancialSupportDemoControllerFindLoans$Params } from '../fn/financial-support-demo/financial-support-demo-controller-find-loans';
import { financialSupportDemoControllerFindOne } from '../fn/financial-support-demo/financial-support-demo-controller-find-one';
import { FinancialSupportDemoControllerFindOne$Params } from '../fn/financial-support-demo/financial-support-demo-controller-find-one';
import { FinancialSupportDemoCreditDto } from '../models/financial-support-demo-credit-dto';
import { FinancialSupportDemoGrantBenefitDto } from '../models/financial-support-demo-grant-benefit-dto';
import { FinancialSupportDemoLoansDto } from '../models/financial-support-demo-loans-dto';

@Injectable({ providedIn: 'root' })
export class FinancialSupportDemoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financialSupportDemoControllerFindAll()` */
  static readonly FinancialSupportDemoControllerFindAllPath = '/api/financial-support/demo-companies';

  /**
   * SGMS 데모 기업 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportDemoControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindAll$Response(params?: FinancialSupportDemoControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinancialSupportDemoCompanySummaryDto>>> {
    const obs = financialSupportDemoControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 데모 기업 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportDemoControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindAll(params?: FinancialSupportDemoControllerFindAll$Params, context?: HttpContext): Observable<Array<FinancialSupportDemoCompanySummaryDto>> {
    const resp = this.financialSupportDemoControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FinancialSupportDemoCompanySummaryDto>>): Array<FinancialSupportDemoCompanySummaryDto> => r.body)
    );
  }

  /** Path part for operation `financialSupportDemoControllerFindOne()` */
  static readonly FinancialSupportDemoControllerFindOnePath = '/api/financial-support/demo-companies/{id}';

  /**
   * SGMS 데모 기업 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportDemoControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindOne$Response(params: FinancialSupportDemoControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoCompanyDto>> {
    const obs = financialSupportDemoControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 데모 기업 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportDemoControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindOne(params: FinancialSupportDemoControllerFindOne$Params, context?: HttpContext): Observable<FinancialSupportDemoCompanyDto> {
    const resp = this.financialSupportDemoControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportDemoCompanyDto>): FinancialSupportDemoCompanyDto => r.body)
    );
  }

  /** Path part for operation `financialSupportDemoControllerFindCredit()` */
  static readonly FinancialSupportDemoControllerFindCreditPath = '/api/financial-support/demo-companies/{id}/credit';

  /**
   * SGMS 데모 신용정보 연동.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportDemoControllerFindCredit()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindCredit$Response(params: FinancialSupportDemoControllerFindCredit$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoCreditDto>> {
    const obs = financialSupportDemoControllerFindCredit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 데모 신용정보 연동.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportDemoControllerFindCredit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindCredit(params: FinancialSupportDemoControllerFindCredit$Params, context?: HttpContext): Observable<FinancialSupportDemoCreditDto> {
    const resp = this.financialSupportDemoControllerFindCredit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportDemoCreditDto>): FinancialSupportDemoCreditDto => r.body)
    );
  }

  /** Path part for operation `financialSupportDemoControllerFindLoans()` */
  static readonly FinancialSupportDemoControllerFindLoansPath = '/api/financial-support/demo-companies/{id}/loans';

  /**
   * SGMS 데모 융자정보 연동.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportDemoControllerFindLoans()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindLoans$Response(params: FinancialSupportDemoControllerFindLoans$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoLoansDto>> {
    const obs = financialSupportDemoControllerFindLoans(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 데모 융자정보 연동.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportDemoControllerFindLoans$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindLoans(params: FinancialSupportDemoControllerFindLoans$Params, context?: HttpContext): Observable<FinancialSupportDemoLoansDto> {
    const resp = this.financialSupportDemoControllerFindLoans$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportDemoLoansDto>): FinancialSupportDemoLoansDto => r.body)
    );
  }

  /** Path part for operation `financialSupportDemoControllerFindGrantBenefits()` */
  static readonly FinancialSupportDemoControllerFindGrantBenefitsPath = '/api/financial-support/demo-companies/{id}/grant-benefits';

  /**
   * SGMS 데모 지원사업 수혜이력 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportDemoControllerFindGrantBenefits()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindGrantBenefits$Response(params: FinancialSupportDemoControllerFindGrantBenefits$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinancialSupportDemoGrantBenefitDto>>> {
    const obs = financialSupportDemoControllerFindGrantBenefits(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 데모 지원사업 수혜이력 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportDemoControllerFindGrantBenefits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportDemoControllerFindGrantBenefits(params: FinancialSupportDemoControllerFindGrantBenefits$Params, context?: HttpContext): Observable<Array<FinancialSupportDemoGrantBenefitDto>> {
    const resp = this.financialSupportDemoControllerFindGrantBenefits$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FinancialSupportDemoGrantBenefitDto>>): Array<FinancialSupportDemoGrantBenefitDto> => r.body)
    );
  }

}
